exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.circle .progressbar-text{\n  font-size: 4rem;\n}\n", ""]);

